import React from 'react';
import { motion } from 'framer-motion';

const Terms = () => {
  return (
    <div className="min-h-screen pt-24 pb-16" data-testid="terms-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <span className="text-sm uppercase tracking-[0.2em] text-[var(--color-primary)] font-medium">
            Legal
          </span>
          <h1 className="text-4xl sm:text-5xl font-semibold tracking-tighter text-[var(--text-primary)] mt-4 mb-4">
            Terms of Use
          </h1>
          <p className="text-[var(--text-secondary)] mb-8">
            Last updated: January 15, 2026
          </p>

          <div className="prose prose-invert max-w-none">
            <div className="space-y-8 text-[var(--text-secondary)]">
              <section>
                <h2 className="text-xl font-semibold text-[var(--text-primary)] mb-4">1. Acceptance of Terms</h2>
                <p>
                  By accessing or using DeFi Bot ("Service"), you agree to be bound by these Terms of Use. If you disagree with any part of these terms, you may not access the Service.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[var(--text-primary)] mb-4">2. Description of Service</h2>
                <p>
                  DeFi Bot is an automated trading bot designed for EVM-compatible blockchain networks. The Service provides tools for automated trading, portfolio management, and market analysis. You acknowledge that:
                </p>
                <ul className="list-disc pl-6 mt-2 space-y-2">
                  <li>Trading cryptocurrencies involves substantial risk of loss</li>
                  <li>Past performance does not guarantee future results</li>
                  <li>You are solely responsible for your trading decisions</li>
                  <li>The Service does not provide financial advice</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[var(--text-primary)] mb-4">3. User Responsibilities</h2>
                <p>You agree to:</p>
                <ul className="list-disc pl-6 mt-2 space-y-2">
                  <li>Provide accurate and complete information when registering</li>
                  <li>Maintain the security of your wallet and API keys</li>
                  <li>Comply with all applicable laws and regulations</li>
                  <li>Not use the Service for any illegal activities</li>
                  <li>Not attempt to reverse engineer or compromise the Service</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[var(--text-primary)] mb-4">4. Non-Custodial Service</h2>
                <p>
                  DeFi Bot is a non-custodial service. We never have access to your private keys, seed phrases, or funds. All transactions are executed directly from your connected wallet. You are solely responsible for securing your wallet credentials.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[var(--text-primary)] mb-4">5. Payment Terms</h2>
                <p>
                  All payments are made in cryptocurrency (USDT or USDC) and are non-refundable. Prices are subject to change without notice. Your subscription grants lifetime access to the features included in your selected plan at the time of purchase.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[var(--text-primary)] mb-4">6. Limitation of Liability</h2>
                <p>
                  TO THE MAXIMUM EXTENT PERMITTED BY LAW, DEFI BOT SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO LOSS OF PROFITS, DATA, OR OTHER INTANGIBLE LOSSES, RESULTING FROM YOUR USE OF THE SERVICE.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[var(--text-primary)] mb-4">7. Risk Disclosure</h2>
                <p>
                  Cryptocurrency trading carries a high level of risk and may not be suitable for all investors. The high degree of leverage can work against you as well as for you. Before deciding to trade cryptocurrencies, you should carefully consider your investment objectives, level of experience, and risk appetite.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[var(--text-primary)] mb-4">8. Modifications to Service</h2>
                <p>
                  We reserve the right to modify or discontinue the Service at any time without notice. We shall not be liable to you or any third party for any modification, suspension, or discontinuance of the Service.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[var(--text-primary)] mb-4">9. Governing Law</h2>
                <p>
                  These Terms shall be governed by and construed in accordance with the laws of the United Kingdom, without regard to its conflict of law provisions. Any disputes shall be resolved in the courts of England and Wales.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[var(--text-primary)] mb-4">10. Contact Information</h2>
                <p>
                  For questions about these Terms, please contact us at:
                </p>
                <p className="mt-2">
                  Email: legal@defi-bot.io<br />
                  Address: 71-75 Shelton Street, Covent Garden, London WC2H 9JQ, United Kingdom
                </p>
              </section>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Terms;
